<template>
  <div>
    <div>
      <div class="thead">
        <h3>Paiement</h3>
        <span class="desktopOnly">Montant</span>
        <span class="desktopOnly">Type</span>
        <span class="desktopOnly">Statut</span>
        <span v-if="payments[0].payment_type === 'Virement'">Justificatif</span>
      </div>
      <div class="tbody">
        <div v-for="payment in pays">
          <span>{{ payment.title }}</span>
          <span>{{ payment.price }}€</span>
          <span class="desktopOnly">{{ payment.payment_type }}</span>
          <span class="action-column">
                        <pill @click.native="openDropDown(payment.id)" :bg-color="paymentColor(payment.status)"
                              style="max-width: 100px; float: right; cursor:pointer;">{{ paymentStatus(payment.status) }}</pill>
                        <div v-if="admin" v-click-outside="close" style="cursor: pointer;" class="actions"
                             :id="'pill-'+payment.id">
                            <div>
                                <pill style="cursor: pointer;" bg-color="pill-danger"
                                      @click.native="changeStatus(payment.id, false)">À payer</pill>
                                <pill style="cursor: pointer;" bg-color="pill-success"
                                      @click.native="changeStatus(payment.id, true)">Receptionné</pill>
                            </div>
                        </div>
                    </span>
          <span v-if="payment.payment_type === 'Virement' && number !== payment.id" class="vir">
                       <label v-if="!payment.attachment" for="inputFile">
                           Ajouter
                           <input type="file" id="inputFile" @change="updateFile($event, payment.id)">
                       </label>
                        <div v-else class="proof-options">
                            <a target="_blank" :title="payment.filename"
                               :href="payment.attachment"><svg xmlns="http://www.w3.org/2000/svg"
                                                               width="24" height="24"
                                                               viewBox="0 0 24 24"><path
                                d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/><path
                                fill="none" d="M0 0h24v24H0z"/></svg>
                            </a>
                            <label for="changeInputFile">
                                <input type="file" id="changeInputFile" @change="updateFile($event, payment.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path
                                    fill="none" d="M0 0h24v24H0V0z"/><path
                                    d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                            </label>
                        </div>

                    </span>
          <span v-else-if="payment.payment_type === 'Virement'">
                        <uni-circular-loader></uni-circular-loader>
                    </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import Pill from "../a-elements/pill";
import ClickOutside from 'vue-click-outside'
import UniCircularLoader from "../a-elements/UniCircularLoader";

export default {
  name: "RichTableRecap",
  components: {UniCircularLoader, Pill},
  props: {
    payments: Array,
    admin: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isMobile: '',
      number: 0,
      pays: []
    }
  },
  computed: {
    ...mapGetters({currentFamily: 'currentFamily'}),
  },
  methods: {
    updateFile(e, id) {
      this.number = id
      const image = {
        'transfer_order': e.target.files[0]
      }

      let formData = new FormData()

      Object.entries(image).forEach(
          ([key, value]) => formData.append(key, value)
      )
      this.$http.put('/admin/payments/' + id, formData)
          .then(response => {
            this.pays = response.data.current_payments
            this.number = 0
          })
          .catch(err => {
            if (this.$isSignatureExpired(err.response.data.message)) {
              this.$store.dispatch('logout')
              this.$router.push({name: 'Login', params: {q: 'expired'}})
            }
          })
    },
    changeStatus(id, status) {

      this.$adminChangePaymentStatus(id, status)
          .then(data => {
            this.$emit('status', data)
          })
    },
    close() {
      let opened = document.querySelector('.actions.open')
      if (opened) {
        opened.classList.remove("open")
        window.setTimeout(() => {
          opened.style.display = "none"
        }, 300)
      }
    },
    openDropDown(id) {
      if (this.currentFamily.isPayment) {
        let opened = document.querySelector('.actions.open')
        if (opened) {
          opened.classList.remove("open")
          window.setTimeout(() => {
            opened.style.display = "none"
          }, 300)
        }

        let div = document.querySelector('#pill-' + id)
        div.style.display = "block"
        window.setTimeout(() => {
          div.classList.add("open")
        }, 100)
      }
    },
    paymentStatus(status) {
      if (status) {
        return "Réceptionné"
      } else if (status === null) {
        return "Réceptionné"
      } else {
        return "À payer"
      }
    },
    paymentColor(status) {
      if (status) {
        return "pill-success"
      } else if (status === null) {
        return "pill-warning"
      } else {
        return "pill-danger"
      }
    }
  },
  updated() {
    this.pays = this.payments
  },
  created() {
    this.pays = this.payments
    const width = window.innerWidth || document.documentElement.clientWidth ||
        document.body.clientWidth
    this.isMobile = width < 768
  },

}
</script>

<style scoped lang="scss">
.desktopOnly {
  display: none;
}

.table {
  width: 100%;
}

.thead {
  display: flex;
  padding: 16px 12px 6px 2px;

  *:first-child {
    width: 100%;
    text-align: left;
  }
}

.tbody {
  border-radius: 8px;
  background: var(--color-grey-light-2);
  margin-bottom: 16px;

  > div {
    display: flex;
    justify-content: space-between;

    span:first-child {
      width: 75px;
      text-align: left;
    }

    span {
      margin-right: 6px;
    }

    .action-column {
      position: relative;
    }

    span:last-child {
      margin-right: 0;
      justify-self: flex-end;

    }

    padding: 8px 12px;
    border-bottom: 1px solid var(--color-grey-light-1);
    align-items: center;
  }

  > div:last-child {
    border: none;
  }
}

.actions {
  display: none;
}

.vir {
  position: relative;

  label {
    cursor: pointer;
  }

  input {
    display: none;
  }

}

.proof-options {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  a {
    margin: 0;

    svg {
      margin-right: 8px;
    }
  }
}

.loader-container {
  justify-content: flex-end;
}

@include screen-m {

  .actions {
    top: -8px;
    left: 100px;
    position: absolute;
    padding: 8px 16px;
    background: var(--color-white);
    box-shadow: var(--shadow-s);
    border-radius: var(--radius-big);
    width: 300px;
    display: none;
    opacity: 0;
    transform: translateX(-15px);
    transition: all .3s ease-in-out;
    z-index: 10;

    &.open {
      opacity: 1;
      transform: translateX(0);
    }

    > div {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 8px;
    }
  }
  .desktopOnly {
    display: initial;
  }
  .thead {
    padding: 16px 16px 8px 2px;

    > * {
      width: 25%;
      text-align: right;
    }

    > *:first-child {
      width: 25%;
    }
  }
  .tbody {
    > div {
      padding: 12px 16px;

      > span:first-child {
        width: 30%;
      }

      > span {
        width: 25%;
        text-align: right;
      }
    }
  }
}
</style>
